import {connectRouter} from 'connected-react-router';
import {combineReducers} from 'redux';

import authReducer from '../features/auth/store/reducer';
import eSingleReducer from '../features/election-single/store/reducer';
import electionReducer from '../features/election/store/reducer';
import history from '../routes/history';
import systemReducer from './system/reducer';

const rootReducer = combineReducers({
  auth: authReducer,
  election: electionReducer,
  eSingle: eSingleReducer,
  router: connectRouter(history),
  system: systemReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/root-reducer.ts